// Aviso permanente "entretenimento por IA" exibido próximo à conversa
// Importante: é um escudo legal e de imagem. Deve estar sempre visível dentro do app.
import React from 'react';
import { DisclaimerBar } from './styled';

const AIDisclaimer = () => {
    return (
        <DisclaimerBar role="note" aria-label="Aviso importante">
            <span aria-hidden="true">⚠️</span> Personagem recriado por IA para entretenimento.
            As respostas não substituem a leitura da Bíblia nem orientação profissional.
        </DisclaimerBar>
    );
};

export default AIDisclaimer;
